import React, { useState } from "react";
import DivButton from "../Generic/DivButton";

function UtilityInput(props) {
  const [label, setLabel] = useState(
    props.displayLabel === undefined
      ? props.id.replace(/([a-z])([A-Z])/g, "$1 $2").trim()
      : props.displayLabel
  );

  var isPercent = props.isPercent === undefined ? false : props.isPercent;

  const clear = () => {
    if (props.clear !== undefined) props.clear();
  };
  // GetLabel();
  function GetLabel() {
    if (props.id.includes("AmountToInvestAnnually") === true) {
      if (parseInt(props.value) < 0) {
        setLabel("Amount To Spend Anually: ");
      } else {
        setLabel("Amount To Invest Anually: ");
      }
    } else {
      setLabel(
        `${
          props.id.includes("_")
            ? props.id.replaceAll("_", " ")
            : props.id.replace(/([a-z])([A-Z])/g, "$1 $2").trim()
        }: `
      );
    }
  }
  // console.log(label);
  return (
    <div className="UtilityInput">
      <div>
        <label htmlFor={props.id}>
          {label.trim() === "ROR:"
            ? "Rate Of Return:"
            : label.trim() === "SD:"
            ? "Standard Deviation:"
            : label}
        </label>
        <div>
          <input
            className="text"
            id={props.id}
            name={props.id}
            onBlur={(event) => {
              props.handleValue(event);
            }}
            onChange={(event) => {
              props.handleChange(event);
              GetLabel();
            }}
            value={
              props.value === undefined
                ? ""
                : isPercent
                ? props.value
                : props.value.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })
            }
            type="text"
            size="10"
          />
          {props.value === "" || props.value === undefined ? "*" : ""}
        </div>
        {props.guidelines === undefined ? (
          <></>
        ) : (
          <p className="guidelines">{props.guidelines}</p>
        )}
      </div>
    </div>
  );
}

export default UtilityInput;
